﻿import {
    ValgStateActionTypes,
    TOGGLE_VILKAR,
    ToggleVilkarAction,
    ValgState,
    UPDATE_VALG,
    TOGGLE_UTBETALING,
    ToogleUtbetalingAction,
} from './Types';

import { ThunkAction, ThunkDispatch } from 'redux-thunk';
import { VeilederUtstyrsstipendAppState } from '..';
import { AnyAction } from 'redux';
import { setVisning } from '../Resultat/Actions';
import AUtdanningsvalg from '../../Utilities/A-Utdanningsvalg';
import BYrkesfag from '../../Utilities/B-Yrkesfag';
import BStudieforberedende from '../../Utilities/B-Studieforberedende';
import AarA from '../../Utilities/C-Aar';
import CAar from '../../Utilities/C-Aar';
import DProgram from '../../Utilities/D-Program';

export function updateValg(newValg: Partial<ValgState>): ValgStateActionTypes {
    return {
        type: UPDATE_VALG,
        payload: newValg,
    };
}

export function toggleUtbetaling(): ToogleUtbetalingAction {
    return {
        type: TOGGLE_UTBETALING,
    };
}

export function toggleVilkar(): ToggleVilkarAction {
    return {
        type: TOGGLE_VILKAR,
    };
}

export const updateVisning = (): ThunkAction<void, VeilederUtstyrsstipendAppState, {}, AnyAction> => {
    return (
        dispatch: ThunkDispatch<VeilederUtstyrsstipendAppState, {}, AnyAction>,
        getState: () => VeilederUtstyrsstipendAppState,
    ): void => {
        const currentState = getState();
        const visStudieforberedendeBa = visBa(currentState);
        const visYrkesfagBb = visBb(currentState);
        // C og D kommer seinere
        const visAarCa: boolean = visCa(currentState);
        const visAarCb: boolean = visCb(currentState);
        const visAarCc: boolean = visCc(currentState);
        const visAarCd: boolean = visCd(currentState);
        const visAarCe: boolean = visCe(currentState);
        const visProgramDa: boolean = visDa(currentState);
        const visProgramDb: boolean = visDb(currentState);
        const visProgramDc: boolean = visDc(currentState);
        const visProgramDd: boolean = visDd(currentState);
        const visProgramDdVg3: boolean = visDdVg3(currentState);
        const visProgramDe: boolean = visDe(currentState);
        const visUtstyrsstipendEa = visEa(currentState);
        const visUtstyrsstipendEb = visEb(currentState);
        const visUtstyrsstipendEc = visEc(currentState);
        const visUtstyrsstipendEd = visEd(currentState);
        const visUtstyrsstipendEe = visEe(currentState);

        dispatch(
            setVisning({
                visStudieforberedendeBa,
                visYrkesfagBb,
                visAarCa,
                visAarCb,
                visAarCc,
                visAarCd,
                visAarCe,
                visProgramDa,
                visProgramDb,
                visProgramDc,
                visProgramDd,
                visProgramDdVg3,
                visProgramDe,
                visUtstyrsstipendEa,
                visUtstyrsstipendEb,
                visUtstyrsstipendEc,
                visUtstyrsstipendEd,
                visUtstyrsstipendEe,
            }),
        );
    };
};

const visBa = (state: VeilederUtstyrsstipendAppState): boolean => {
    return getA(state) === AUtdanningsvalg.a1;
};
const visBb = (state: VeilederUtstyrsstipendAppState): boolean => {
    return getA(state) === AUtdanningsvalg.a2;
};

const visCa = (state: VeilederUtstyrsstipendAppState): boolean => {
    return state.valg.bYrkesfag?.value === BYrkesfag.bb3;
};

const visCb = (state: VeilederUtstyrsstipendAppState): boolean => {
    return state.valg.bYrkesfag?.value === BYrkesfag.bb7;
};

const visCc = (state: VeilederUtstyrsstipendAppState): boolean => {
    return state.valg.bYrkesfag?.value === BYrkesfag.bb10;
};

const visCd = (state: VeilederUtstyrsstipendAppState): boolean => {
    return state.valg.bStudieforberedende?.value === BStudieforberedende.ba1;
};

const visCe = (state: VeilederUtstyrsstipendAppState): boolean => {
    return state.valg.bStudieforberedende?.value === BStudieforberedende.ba5;
};

const visDa = (state: VeilederUtstyrsstipendAppState): boolean => {
    return state.valg.cAar?.value === AarA.ca2 || state.valg.cAar?.value === AarA.ca3;
};

const visDb = (state: VeilederUtstyrsstipendAppState): boolean => {
    return state.valg.cAar?.value === AarA.cb3;
};


const visDc = (state: VeilederUtstyrsstipendAppState): boolean => {
    return state.valg.cAar?.value === AarA.cc2 ;
};

const visDd = (state: VeilederUtstyrsstipendAppState): boolean => {
    return state.valg.cAar?.value === AarA.cd2 ||
    state.valg.cAar?.value === AarA.cd1;
};

const visDdVg3 = (state: VeilederUtstyrsstipendAppState): boolean => {
    return state.valg.cAar?.value === AarA.cd3;
};

const visDe = (state: VeilederUtstyrsstipendAppState): boolean => {
    return state.valg.cAar?.value === AarA.ce2 ||
    state.valg.cAar?.value === AarA.ce3;
};

const getA = (state: VeilederUtstyrsstipendAppState): string | undefined => {
    return state.valg.aUtdanningsValg?.value;
};

const visEa = (state: VeilederUtstyrsstipendAppState): boolean => {
    return (
        state.valg.dProgram?.value === DProgram.de2 ||
        state.valg.dProgram?.value === DProgram.dd2 ||  
        state.valg.cAar?.value === CAar.ce1 || 
        getBa(state) === BStudieforberedende.ba4 ||
        state.valg.dProgram?.value === DProgram.dd2vg3 ||
        state.valg.dProgram?.value === DProgram.dd3vg3 

    );
};
const visEb = (state: VeilederUtstyrsstipendAppState): boolean => {
    return (
        getBa(state) === BStudieforberedende.ba3 || 
        getBb(state) === BYrkesfag.bb5 ||
        getBb(state) === BYrkesfag.bb6 ||
        getBb(state) === BYrkesfag.bb9 ||
        state.valg.dProgram?.value === DProgram.dc1 || 
        state.valg.dProgram?.value === DProgram.db1 
        
    );
};
const visEc = (state: VeilederUtstyrsstipendAppState): boolean => {
    return (
        getBb(state) === BYrkesfag.bb2 || 
        state.valg.cAar?.value === CAar.cc1 ||
        state.valg.cAar?.value === CAar.ca1 || 
        state.valg.dProgram?.value === DProgram.da2 || 
        state.valg.dProgram?.value === DProgram.dc2 ||
        state.valg.dProgram?.value === DProgram.dd1  ||
        state.valg.dProgram?.value === DProgram.dd1vg3 || 
        state.valg.cAar?.value === AarA.cc3
    );
};
const visEd = (state: VeilederUtstyrsstipendAppState): boolean => {
    return (
        state.valg.dProgram?.value === DProgram.de1 ||
        getBa(state) === BStudieforberedende.ba2
    );
};

const visEe = (state: VeilederUtstyrsstipendAppState): boolean => {
    return (
        getBb(state) === BYrkesfag.bb1 ||
        getBb(state) === BYrkesfag.bb4 ||
        getBb(state) === BYrkesfag.bb8 ||
        state.valg.cAar?.value === CAar.cb1 ||
        state.valg.cAar?.value === CAar.cb2 ||
        state.valg.dProgram?.value === DProgram.da1 || 
        state.valg.dProgram?.value === DProgram.db2 
    );
};

const getBa = (state: VeilederUtstyrsstipendAppState): string | undefined => {
    //  state.valg.bYrkesfag = undefined;
    return state.valg.bStudieforberedende?.value;
};

const getBb = (state: VeilederUtstyrsstipendAppState): string | undefined => {
    //  state.valg.bStudieforberedende = undefined;
    return state.valg.bYrkesfag?.value;
};
